<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
          }}</span>
        <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Export') != -1" type="primary" class="btn primary" @click="exportData"
            v-loading="exportButtonLoading" :disabled="exportButtonLoading">导出</el-button>
            <el-button type="primary" class="btn primary" @click="manualPush"
            v-loading="manualPushLoading" :disabled="manualPushDisabled">手动推送</el-button>
            
          <!-- <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick @click="handleAdd">新增</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" size="small" :disabled="multiple" v-preventReClick @click="handleDelete">删除</el-button>
          <el-dropdown v-if="tableAcl.indexOf('Print') != -1" @command="print">
            <el-button v-if="tableAcl.indexOf('Print') != -1" class="btn primary" type="primary">
              打印
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="0">打印</el-dropdown-item>
              <el-dropdown-item command="1">预览</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->
          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange"
            @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <el-table ref="multipleTable" border v-loading="loading" :data="tableData" :max-height="tableHeight"
        style="width: 100%" @selection-change="handleSelectionChange" :span-method="objectSpanMethod" stripe
        :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
         <el-table-column type="selection" width="50"> </el-table-column>
        <el-table-column type="index" width="50"> </el-table-column>
        <el-table-column prop="no" width="170" label="RFID码" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>
              <el-link type="primary" @click="handleUpdate(scope.row)">{{ scope.row.no }}</el-link>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="supplierProductNo" label="供应商产品编码" width="180"></el-table-column>
        <el-table-column show-overflow-tooltip prop="productName" width="160" label="产品名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="specName" width="120" label="规格型号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="manufacturerName" width="150" label="生产厂家"></el-table-column>
        <el-table-column show-overflow-tooltip prop="deptName" width="150" label="使用科室"></el-table-column>
        <el-table-column show-overflow-tooltip prop="warehouseName" width="150" label="科室库房">
          <template slot-scope="scope">
            {{scope.row.warehouseName?scope.row.warehouseName:'-'}}
          </template>
        </el-table-column>

        <el-table-column prop="validityDate" label="有效期" width="160">
          <template slot-scope="scope">
            {{
              scope.row.validityDate
                ? parseTime(new Date(scope.row.validityDate), "{y}-{m}-{d}")
                : "-"
            }}
          </template>
        </el-table-column>
        <el-table-column prop="longTime" label="长期" width="60">
          <template slot-scope="scope">
            {{ scope.row.longTime == 1 ? "是" : "否" }}
          </template>
        </el-table-column>
        <el-table-column prop="batch" label="批次号" width="120" />
        <el-table-column prop="serialNo" label="序列号" width="120">
          <template slot-scope="scope">
            {{scope.row.serialNo?scope.row.serialNo:'-'}}
          </template>
        </el-table-column>
        <el-table-column prop="number" width="80" label="数量"></el-table-column>
        <el-table-column prop="unit" width="80" label="包装单位">
          <template slot-scope="scope">
            {{scope.row.unit?scope.row.unit:'-'}}
          </template>
        </el-table-column>
        <el-table-column prop="minUnit" width="80" label="最小单位"></el-table-column>
        <el-table-column prop="price" width="80" label="单价"></el-table-column>
        <el-table-column show-overflow-tooltip prop="mainNo" width="160" label="主条码">
          <template slot-scope="scope">
            {{scope.row.mainNo?scope.row.mainNo:'-'}}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="traceNo" width="160" label="溯源码">
          <template slot-scope="scope">
            {{scope.row.traceNo?scope.row.traceNo:'-'}}
          </template>
        </el-table-column>
        <el-table-column prop="stateName" width="100" label="RFID状态"></el-table-column>
        <el-table-column show-overflow-tooltip prop="productRegistCertNo" label="注册证号" width="180"></el-table-column>
        <el-table-column prop="stockCategoryName" width="80" label="库存类型"></el-table-column>
        <el-table-column prop="useStateName" width="80" label="状态"></el-table-column>
        <el-table-column prop="dataNo" width="170" label="来源单号"></el-table-column>
        <el-table-column prop="medicalInsuranceCategoryNo" show-overflow-tooltip label="医保代码"
          width="200"></el-table-column>
        <el-table-column fixed="right" prop="printingTimes" width="80" label="打印次数"></el-table-column>
        <el-table-column fixed="right" prop="operation" label="操作" width="180">
          <template slot-scope="scope">
            <!-- <el-button type="text" v-preventReClick @click="handleUpdate(scope.row)" class="color-blue">查看详情</el-button> -->
            <el-button v-if="scope.row.state != 0 && scope.row.useState != 1" type="text" v-preventReClick
              @click="handleDelete(scope.row)" class="margin-left20 color-blue">作废</el-button>
            <el-button type="text" v-if="scope.row.state != 0" @click="print(scope.row)"
              class="margin-left20 color-blue">打印</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange"
        :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>

    <el-dialog title="查看详情" :visible.sync="open" :center="true" width="800px">
      <el-table :data="details" border ref="multipleTable" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <el-table-column type="index" width="50"> </el-table-column>
        <el-table-column prop="createdTime" label="时间">
          <template slot-scope="scope">
            {{ scope.row.createdTime ? parseTime(new Date(scope.row.createdTime)) : "" }}
          </template>
        </el-table-column>
        <el-table-column prop="createdUserName" label="操作人" />
        <el-table-column prop="stateName" label="操作类型"> </el-table-column>
        <el-table-column prop="dataNo" label="单号"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn" size="small" v-preventReClick @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetPackDetailsByNo,
  GetPackViewModels,
  RemovePack,
  GetPackPrintData,
  ExportProductRfid,
  SendPacks,
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import { RFIDStateOptions, StockCategoryOptions, PackLogStateOptions,WhetherOptions } from "@/enum";
import SelectFilter from "@/components/table-select-filter";

export default {
  mixins: [GetDataMixin, GetDataSpdMixin],
  components: {
    SelectFilter,
  },
  data () {
    return {
      GetDatasAction: GetPackViewModels,
      RemoveAction: RemovePack,
      exportAction: ExportProductRfid,
      RFIDStateOptions: RFIDStateOptions,
      StockCategoryOptions: StockCategoryOptions,
      PackLogStateOptions: PackLogStateOptions,
      WhetherOptions:WhetherOptions,
      filterOptions: [
        {
          name: "RFID状态",
          type: "select",
          code: "state",
          data: RFIDStateOptions,
        },
        {
          name: "供货商产品",
          type: "select",
          code: "supplierProductId",
          filterMethod: this.getSupplierProductsNoDebounce,
          data: [],
        },
        {
          name: "供应商产品编码",
          type: "input",
          code: "supplierProductNo",
        },
        {
          name: "产品名称",
          type: "input",
          code: "productName",
        },
        {
          name: "规格型号",
          type: "input",
          code: "specName",
        },
        {
          name: "生产厂家",
          type: "select",
          code: "manufacturerId",
          filterMethod: this.getManufacturers,
          data: [],
        },
        {
          name: "使用科室",
          type: "select",
          code: "deptId",
          filterMethod: this.getDepts,
          data: [],
        },
        {
          name: "赋码人",
          type: "select",
          code: "createdUser",
          filterMethod: this.getUsers,
          data: [],
        },
        {
          name: "库存类型",
          type: "select",
          code: "stockCategory",
          data: StockCategoryOptions,
        },
        {
          name: "RFID码",
          type: "input",
          code: "keyWord",
        },
        {
          name: "主条码",
          type: "input",
          code: "mainNo",
        },
        {
          name: "溯源码",
          type: "input",
          code: "traceNo",
        },
        {
          name: "批次号",
          type: "input",
          code: "batch",
        },
        {
          name: "单号",
          type: "input",
          code: "dataNo",
        },
        {
          name: "操作人",
          type: "select",
          code: "operationUserId",
          filterMethod: this.getUsers,
          data: [],
        },
        {
          name: "操作类型",
          type: "select",
          code: "operationType",
          data: PackLogStateOptions,
        },
        {
          name: "操作日期范围",
          type: "date",
          code: "operationDate",
          startDateCode: "operationStartDate",
          endDateCode: "operationEndDate",
        },
        {
          name: "赋码日期范围",
          type: "date",
          code: "date",
        },
        {
          name: "是否可退",
          type: "select",
          code: "rfidReturn",
          data:WhetherOptions
        },  
      ],
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        loginDeptId: this.mySessionStorage.getDeptId(),
        loginWarehouseId: this.mySessionStorage.getWarehouseId(),
      },
      // 列表数据
      tableData: [],
      // 列表总数
      total: 0,
      // 多选框数据
      ids: [],
      multipleSelection: [],
      // 列表多选
      multiple: true,
      details: [],
      open: false,
      spanArr: [],
      manualPushLoading:false,
      manualPushDisabled:true
    };
  },
  computed: {
    system_setting () {
      return this.$store.getters.system_setting;
    },
  },
  mounted () {
    this.getData();
    this.rfidSocketApi.init(this.onmessage, this.onopen);
  },
  beforeDestroy () {
    this.rfidSocketApi.clearBingMethods();
  },
  methods: {
    // 获取列表
    getData () {
      this.GetDatasAction(this.query)
        .then((res) => {
          this.tableData = res.returnData.data;
          this.total = res.returnData.totalCount;

          this.getSpanArr(this.tableData);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleDelete (row) {
      // const ids = row && row.id ? [row.id] : this.ids;

      this.$my_confirm(`此操作将作废包号：${row.no}吗？`, "提示", {
        type: "warning",
      })
        .then(() => {
          return this.RemoveAction({
            no: row.no,
          });
        })
        .then(() => {
          this.$my_message(`操作成功！`, "success");
          this.getData();
        })
        .catch(() => { });
    },
    // 改变当前页
    changePage (val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },
    handleSizeChange (val) {
      this.$set(this.query, "pageSize", val);
      this.getData();
    },

    // 重置
    reset () {
      this.query = {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        loginDeptId: this.mySessionStorage.getDeptId(),
        loginWarehouseId: this.mySessionStorage.getWarehouseId(),
        orgCode :sessionStorage.getItem('orgId')
      };
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
      this.ids = [];
      this.multipleSelection = [];
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection();
      }
      this.loading = true;
      this.getData();
    },
    queryChange () {
      this.$set(this.query, "pageIndex", 1);
      this.loading = true;
      this.getData();
    },
    // 编辑操作
    handleUpdate (row) {
      // this.id = row.id
      this.open = true;
      GetPackDetailsByNo({
        no: row.no,
      }).then((res) => {
        this.details = res.returnData;
      });
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      this.open = false;
      this.getData();
    },

    getSpanArr (data) {
      this.spanArr = [];
      if (!data) {
        return;
      }
      // data就是我们从后台拿到的数据
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push(1);
          this.pos = 0;
        } else {
          // 判断当前元素与上一个元素是否相同
          if (data[i].no === data[i - 1].no) {
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.pos = i;
          }
        }
      }
    },
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      
      if (column.property == "no" || column.property == "operation"|| column.type === "selection") {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },

    onmessage (e) {
      window.console.log("收到消息啦:" + e.data);
      var data = JSON.parse(e.data);
      if (data.Successful) {
        this.$my_message("打印成功", "success");
      } else {
        this.$my_message("打印失败：" + data.Message, "error");
      }
    },
    onopen () {
      window.console.log("连接成功了哦");
    },
    print (row) {
      GetPackPrintData({
        no: row.no,
      }).then((res) => {
        var action = "PrintSingle";
        if (row.no.startsWith("BDB")) {
          action = "PrintPack";
        }
        if(this.system_setting.RFIDTempSite){
          this.$my_message("打印成功", "success");
           this.getData();
          return
        }
        var data = {
          Action: action,
          Content: res.returnData,
        };
        this.rfidSocketApi.sendSock(data);

        this.getData();
      });
    },

    showRFIDDialog (row) {
      this.$router.push("/pack-edit?category=0&id=" + row.id);
    },
    manualPush(){
      this.manualPushLoading = true;
      this.manualPushDisabled = true;
      if(this.multipleSelection.length == 0){
        this.$my_message("请选择数据", "warning");
        this.manualPushLoading = false;
        this.manualPushDisabled = false;
        return;
      }
      let ids = this.ids
      SendPacks({
        ids: ids
      }).then((res) => {
        this.$my_message("操作成功！", "success");
        this.getData();
        this.manualPushLoading = false;
        this.manualPushDisabled = false;
      })
    },
  },
};
</script>

<style lang="scss" scoped></style>
